// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"97acc8c2","902":"80bb68b8"}[chunkId] + ".chunk.css";
};